import React from "react";
const SvgTestCheck = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path
      d="M9.6 13.333l-.933-.933 1.734-1.733-1.734-1.734L9.601 8l1.733 1.733L13.067 8l.934.933-1.734 1.734 1.734 1.733-.934.933-1.733-1.733-1.733 1.733zm1.317-6L8.551 4.967l.933-.934 1.417 1.417 2.833-2.833.933.95-3.75 3.766zm-9.583 4V10h6v1.333h-6zm0-5.333V4.667h6V6h-6z"
    />
  </svg>
);
export default SvgTestCheck;
